/* Blog search: article-only predictive search using Shopify's native /search/suggest.json. No dependencies. */
(function () {
  if (customElements.get('blog-search')) return;

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function imageSrc(a) {
    if (!a || !a.image) return '';
    if (typeof a.image === 'string') return a.image;
    return a.image.url || a.image.src || '';
  }

  customElements.define('blog-search', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-input]');
      this.panel = this.querySelector('[data-panel]');
      this.status = this.querySelector('[data-status]');
      this.clearBtn = this.querySelector('[data-clear]');
      if (!this.input || !this.panel) return;

      this.limit = parseInt(this.dataset.limit || '6', 10);
      this.blogPath = '/blogs/' + (this.dataset.blogHandle || 'news') + '/';
      this.noResults = this.dataset.noResults || 'No matches for that one.';
      this.timer = null;
      this.controller = null;
      this.activeIndex = -1;
      this.results = null;

      this.input.addEventListener('input', this.onInput.bind(this));
      this.input.addEventListener('keydown', this.onKeydown.bind(this));
      this.input.addEventListener('focus', this.onFocus.bind(this));
      this.clearBtn.addEventListener('click', this.reset.bind(this));
      this._docClick = this.onDocClick.bind(this);
      document.addEventListener('click', this._docClick);

      this.toggleClear();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._docClick);
      clearTimeout(this.timer);
      if (this.controller) this.controller.abort();
    }

    onDocClick(e) { if (!this.contains(e.target)) this.close(); }
    onFocus() { if (this.results && this.results.length) this.open(); }
    toggleClear() { this.clearBtn.hidden = this.input.value.trim() === ''; }

    onInput() {
      this.toggleClear();
      var q = this.input.value.trim();
      clearTimeout(this.timer);
      if (q.length < 2) { this.close(); this.results = null; return; }
      var self = this;
      this.timer = setTimeout(function () { self.search(q); }, 250);
    }

    onKeydown(e) {
      if (e.key === 'Escape') { this.close(); this.input.blur(); return; }
      if (!this.results || !this.results.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        var dir = e.key === 'ArrowDown' ? 1 : -1;
        this.activeIndex = (this.activeIndex + dir + this.results.length) % this.results.length;
        this.highlight();
      } else if (e.key === 'Enter' && this.activeIndex > -1) {
        e.preventDefault();
        window.location.href = this.results[this.activeIndex].url;
      }
    }

    highlight() {
      var items = this.panel.querySelectorAll('.blog-search__item');
      var idx = this.activeIndex;
      Array.prototype.forEach.call(items, function (el, i) {
        var on = i === idx;
        el.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on && el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
      });
    }

    search(q) {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      var self = this;

      var url = '/search/suggest.json'
        + '?q=' + encodeURIComponent(q)
        + '&resources[type]=article'
        + '&resources[limit]=' + this.limit
        + '&resources[options][fields]=title,body,tag';

      fetch(url, { signal: this.controller.signal })
        .then(function (res) {
          if (!res.ok) throw new Error('search failed');
          return res.json();
        })
        .then(function (data) {
          var all = (data.resources && data.resources.results && data.resources.results.articles) || [];
          self.results = all.filter(function (a) {
            return a && a.url && a.url.indexOf(self.blogPath) !== -1;
          });
          self.activeIndex = -1;
          self.render(q);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          self.close();
        });
    }

    render(q) {
      var html = '';

      if (!this.results.length) {
        html = '<p class="blog-search__message">' + esc(this.noResults) + '</p>';
        this.status.textContent = 'No articles found';
      } else {
        this.results.forEach(function (a, i) {
          var tag = (a.tags && a.tags.length) ? a.tags[0] : '';
          var src = imageSrc(a);
          var img = src
            ? '<img class="blog-search__thumb" src="' + esc(src) + '" alt="" loading="lazy" width="52" height="52">'
            : '<span class="blog-search__thumb" aria-hidden="true"></span>';
          html += '<a class="blog-search__item" role="option" aria-selected="false" id="bs-opt-' + i + '" href="' + esc(a.url) + '">'
            + img
            + '<span><span class="blog-search__title">' + esc(a.title) + '</span>'
            + (tag ? '<span class="blog-search__tag">' + esc(tag) + '</span>' : '')
            + '</span></a>';
        });
        this.status.textContent = this.results.length + ' article' + (this.results.length === 1 ? '' : 's') + ' found';
      }

      html += '<a class="blog-search__all" href="/search?type=article&options%5Bprefix%5D=last&q='
        + encodeURIComponent(q) + '">See all results for &ldquo;' + esc(q) + '&rdquo;</a>';

      this.panel.innerHTML = html;
      this.open();
    }

    open() { this.panel.hidden = false; this.input.setAttribute('aria-expanded', 'true'); }
    close() { this.panel.hidden = true; this.input.setAttribute('aria-expanded', 'false'); this.activeIndex = -1; }

    reset() {
      this.input.value = '';
      this.results = null;
      this.toggleClear();
      this.close();
      this.input.focus();
    }
  });
})();